import { DEFAULT_COUNTRY_CODE } from "../../utils/utils";

const profileMapper = (profileObj) => {
  const { user = {}, customer = {} } = profileObj;
  return {
    // user
    userId: user?.userId,
    shortName: `${user?.firstName?.[0].toUpperCase() || ""} ${
      user?.lastName?.[0].toUpperCase() || ""
    }`,
    name: `${user?.firstName || ""} ${user?.middleName || ""} ${
      user?.lastName || ""
    }`,
    firstName: user?.firstName || "",
    middleName: user?.middleName || "",
    lastName: user?.lastName || "",
    city: user?.city,
    addressLine1: user?.addressLine1,
    stateCode: user?.stateCode,
    postalCode: user?.postalCode,
    userEmail: user?.userEmail,
    phoneNumber: user?.phone?.phoneNumber,
    countryCode: user?.phone?.intlDialCd || DEFAULT_COUNTRY_CODE,

    // company
    companyName: customer?.companyName,
    companyCity: customer?.city,
    companyAddressLine1: customer?.addressLine1,
    companyStateCode: customer?.stateCode,
    companyPostalCode: customer?.postalCode,
    companyPhoneNumber: customer?.phone?.phoneNumber,
    companyCountryCode: customer?.phone?.intlDialCd || DEFAULT_COUNTRY_CODE,
    companyEmail: customer?.customerEmail,
  };
};

export const getSubmitData = (profileObj) => ({
  user: {
    firstName: profileObj?.firstName || "",
    middleName: profileObj?.middleName || "",
    lastName: profileObj?.lastName || "",
    city: profileObj?.city || "",
    addressLine1: profileObj?.addressLine1 || "",
    stateCode: profileObj?.stateCode || "",
    postalCode: profileObj?.postalCode || "",
    phone: {
      phoneNumber: profileObj?.phoneNumber || "",
      intlDialCd: profileObj?.countryCode || "",
    },
  },
  customer: {
    companyName: profileObj?.companyName || "",
    city: profileObj?.companyCity || "",
    addressLine1: profileObj?.companyAddressLine1 || "",
    stateCode: profileObj?.companyStateCode || "",
    postalCode: profileObj?.companyPostalCode || "",
    customerEmail: profileObj?.companyEmail || "",
    phone: {
      phoneNumber: profileObj?.companyPhoneNumber || "",
      intlDialCd: profileObj?.companyCountryCode || "",
    },
  },
});

export default profileMapper;
